export default {
  PHYSICAL_PAIN: "physicalPain",
  FEAR: "fear",
  LIFE_ACTIVITIES_MENTAL_PAIN: "lifeActivitiesMentalPain",
  DISTORTION_MENTAL_PAIN: "distortionMentalPain",
  OTHER_MENTAL_PAIN: "otherMentalPain",
  OTHER_WITH_DOCUMENTS: "otherWithDocuments",
}
